import script from "./SearchAsYouType.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchAsYouType.vue?vue&type=script&setup=true&lang=ts"

import "./SearchAsYouType.vue?vue&type=style&index=0&id=abc54672&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abc54672"]])

export default __exports__